import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { financingPageData, financingFAQs } from "./financingdata";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForEmbeddedFinancing() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <div className="bg-slate-50 min-h-screen">
      <BazAIHelmet
        title="Embedded B2B Financing — Increase Order Value 60% with AI-Powered BNPL"
        description="EkkBaz AI Embedded Financing lets you offer B2B BNPL, invoice financing, and revolving credit at checkout — increasing average order value by 60% and customer retention by 40%."
        keywords="B2B embedded financing, B2B BNPL, invoice financing platform, B2B credit management, buy now pay later B2B, embedded finance"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/product/financing`}
        productName="Embedded Financing"
        faqItems={financingFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Embedded Financing"
        subtitle="Remove cash flow barriers and supercharge order values. Offer B2B BNPL, invoice financing, and credit lines — approved in 5 minutes, embedded at checkout."
        from="financing"
      />
      <EnhancedPageLayout {...financingPageData} />
      <UpdateFooter />
    </div>
  );
}
